import { Component, HostListener, ElementRef, Input } from '@angular/core';
import {
  trigger,
  state,
  query,
  style,
  animate,
  transition,
  keyframes
} from '@angular/animations';

@Component({
  selector: 'contact-box',
  template: `
  <a href="{{this.getUrl()}}" [@boxState]="state">
    <img src="{{this.getImg()}}" class="logo"/>
  </a>
  `,
  styleUrls: ['./contactBox.component.scss'],
  animations: [
   trigger('boxState', [
     state('in', style({
       opacity: 0.5,
       transform: 'scale(1.5)'
     })),
     state('out',   style({
       opacity: 1,
       transform: 'scale(1)'
     })),
     state('boom',   style({
       opacity: 0,
       transform: 'scale(10)'
     })),
     transition('* => boom', animate('300ms')),
     transition('* => in', animate('300ms')),
     transition('in => out', animate('300ms')),
     transition('out => in', animate('300ms'))
   ])
 ]
})
export class ContactBoxComponent {
  @Input() page: string = '';
  @Input() img: string = '';
  state = 'out'

  constructor(public el: ElementRef) { }

  @HostListener('mouseover', ['$event'])
  @HostListener('mouseleave', ['$event'])
  onHover(event: MouseEvent) {
    const direction = event.type === 'mouseover' ? 'in' : 'out';
    if(direction === 'in'){
      this.state = 'in'
    }else {
      this.state = 'out'
    }
  }

  getUrl(){
    return this.page;
  }
  getImg(){
    return this.img;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/contactBox/contactBox.component.ts